import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createSalaryComponent = async (data) => {
  const res = await axiosInstance.post("/api/salary-components-portal/create", data);
  return res.data;
};

export const getAllSalaryComponents = async (filters = {}) => {
  const res = await axiosInstance.get("/api/salary-components-portal/all", { params: filters });
  return res.data;
};

export const updateSalaryComponent = async (id, data) => {
  const res = await axiosInstance.put(`/api/salary-components-portal/update/${id}`, data);
  return res.data;
};

export const toggleSalaryComponentActive = async (id) => {
  const res = await axiosInstance.put(`/api/salary-components-portal/toggle/${id}`);
  return res.data;
};
